// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__2nz3f","noInteraction":"EventWrapper_noInteraction__1QTrk"};